<!-- Copyright (c) ArubaCC - All Rights Reserved. -->
<div class="flex flex-col w-full h-full">
  <div class="w-full border-b-2 p-3">
    <img [src]="logoPath" [alt]="pageTitle" width="232" height="28" />
  </div>
  <div class="flex flex-col justify-center items-center w-full h-full text-center px-3">
    <div class="flex flex-col items-start max-w-4/5 sm:max-w-[352px]">
      <p class="text-left text-4xl pb-6">{{ 'USER_SUSPENDED.TITLE' | transloco }}</p>

      <aup-notification-bar
        title="{{ 'USER_SUSPENDED.TITLE' | transloco }}"
        message="{{ 'USER_SUSPENDED.MESSAGE' | transloco }}"
        [type]="EAppNotificationType.ERROR"
        [dismissable]="false"
        class="w-full"
      ></aup-notification-bar>

      <div class="w-full border-t-2 mt-6 pt-3">
        <a mat-button color="primary" (click)="authService.logout()">
          <mat-icon svgIcon="arrow-left"></mat-icon>
          <span>{{ 'USER_SUSPENDED.BACK_TO_LOGIN' | transloco }}</span>
        </a>
      </div>
    </div>
  </div>
</div>
